import Vue from "vue";
import { NavBar, Button, Icon, Toast, Loading, Cell, CellGroup, Field } from "vant";

import "vant/lib/vant-css/base.css";
import "vant/lib/vant-css/nav-bar.css";
import "vant/lib/vant-css/button.css";
import "vant/lib/vant-css/toast.css";
import "vant/lib/vant-css/loading.css";
import "vant/lib/vant-css/cell.css";
import "vant/lib/vant-css/field.css";

Vue.use(NavBar);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Toast);
Vue.use(Loading);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
